import { createApp } from 'vue';
import store from '../pre_chat/store';
import App from '../pre_chat/App.vue';
import { plugin, defaultConfig } from '@formkit/vue';

import {
  startsWithPlus,
  isPhoneNumberValidWithDialCode,
} from 'shared/helpers/Validators';
import { createI18n } from 'vue-i18n';
import i18nMessages from 'shared/i18n';
import { directive as onClickaway } from 'vue3-click-away';
import * as Sentry from '@sentry/vue';

const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  messages: i18nMessages,
});

const app = createApp(App);

if (window.errorLoggingConfig) {
  Sentry.init({
    app,
    dsn: window.errorLoggingConfig,
    denyUrls: [
      // Chrome extensions
      /^chrome:\/\//i,
      /chrome-extension:/i,
      /extensions\//i,

      // Locally saved copies
      /file:\/\//i,

      // Safari extensions.
      /safari-web-extension:/i,
      /safari-extension:/i,
    ],
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Logs
    enableLogs: true,
  });
}

app.use(i18n);
app.use(store);
app.use(
  plugin,
  defaultConfig({
    rules: {
      startsWithPlus: ({ value }) => startsWithPlus(value),
      isValidPhoneNumber: ({ value }) => isPhoneNumberValidWithDialCode(value),
    },
  })
);
app.directive('on-clickaway', onClickaway);

window.onload = () => {
  app.mount('#app');
};
